.fp-icons-input
  label.fp-icons-input--left-icon(:for='id')
    i.fp-icon.fp-glyph-lock.-color-shade-500.-s16
  input.fp-input-text(:id='id' v-model='value' @input='onUpdate' :type='showValue ? "text" : "password"' :placeholder=`t(placeholderKey)` :autocomplete='autocomplete' :class='{"-touched": alert}' :disabled='disabled' required data-test='value')
  .fp-icons-input--right-icon
    button.fp-icon.fp-glyph-eye.-s16.-pointer(type='button' :class='showValue ? "fp-glyph-eye": "fp-glyph-eye-slash"' @click=`toggleValue` data-test='toggle')
